const testimonials = [
  {
    name: "Sadie",
    quote:
      "I've been living in high stress for well over a year and came to Jess in the hopes of finding some balance and peace through her coaching. The simple practice of grounding before we began our session was so helpful—to be reminded that I can be present and calm in a given moment. I hope to continue having sessions with her to learn coping skills and be given more guidance on how I can approach the current hurdles and struggles I'm facing in life.",
  },
  {
    name: "Colleen",
    quote:
      "I enjoyed my coaching session with Jess Eisaman very much. I felt seen and heard and relaxed. I also felt challenged by her questions to keep me moving forward. She reminded me to breathe. By doing this I felt calm and able to analyze what was concerning me that day in a healthy mental state. When I am perseverating, I think through and practice the breathing exercises, which calm me and allow me to think more clearly. This was very helpful.",
  },
  {
    name: "Sadie",
    context: "A few weeks later",
    quote:
      "I did some of these today when I was feeling unhinged. Thank you again—your coaching is genuinely making a difference for me, and I'm not just saying that because I knew you personally prior.",
  },
  {
    name: "R. H.",
    quote:
      "After our time together on Friday, I'm more willing to consider the effects high-control religion has had on my adult life. That is so hard for me because it really didn't start until I went to BJU and married my husband. Even though I was raised in a KJV-only church, our family was the outlier. Things were one way at church and we definitely lived differently at home. I think my parents just went to that church because it was close and convenient.",
  },
  {
    name: "Beth",
    quote:
      "I have been feeling underappreciated and wandering for a purpose—wondering if I am on the right path for myself. Jess helped me feel like my talents are valuable and should be used. She helped me change the stress I have been having around my talents, and helped me see how I can change my own mindset about myself so I can explain myself to others and be confident in what I feel about my ideas.",
  },
];

const Testimonials = () => (
  <section
    className="bg-[#F6F1EA] py-16 sm:py-20 border-t border-[#D7B2A3]/30"
    data-testid="testimonials-section"
  >
    <div className="max-w-[1100px] mx-auto px-6 sm:px-8">
      <div className="max-w-2xl mb-10">
        <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-6">In their own words</p>
        <h2
          className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#4F5D4F] leading-[1.15] tracking-tight"
          data-testid="testimonials-headline"
        >
          Women becoming <em className="italic text-[#B89B63]">themselves</em>.
        </h2>
      </div>

      {/* Masonry-style two-column layout via CSS columns */}
      <div className="md:columns-2 md:gap-8 space-y-8 md:space-y-0" data-testid="testimonials-grid">
        {testimonials.map((t, i) => (
          <figure
            key={i}
            className="relative bg-white border border-[#D7B2A3]/70 p-8 sm:p-10 md:mb-8 break-inside-avoid"
            data-testid={`testimonial-card-${i}`}
          >
            {/* Serif quote mark ornament */}
            <span
              className="absolute top-4 left-6 font-serif text-6xl leading-none text-[#B89B63]/50 select-none"
              aria-hidden="true"
            >
              &ldquo;
            </span>

            <blockquote className="mt-6 font-serif italic text-lg sm:text-xl text-[#4F5D4F] leading-[1.6]">
              {t.quote}
            </blockquote>

            <figcaption className="mt-8 flex items-baseline justify-end gap-3">
              <span className="w-6 h-px bg-[#B89B63]" aria-hidden="true" />
              <span className="text-xs tracking-eyebrow uppercase text-[#4F5D4F]" data-testid={`testimonial-name-${i}`}>
                {t.name}
              </span>
              {t.context && (
                <span className="text-[10px] tracking-eyebrow uppercase text-[#8C9A88] italic" data-testid={`testimonial-context-${i}`}>
                  · {t.context}
                </span>
              )}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
